import { render } from "./EditorSubject.vue?vue&type=template&id=cdeceb70&scoped=true"
import script from "./EditorSubject.vue?vue&type=script&lang=js"
export * from "./EditorSubject.vue?vue&type=script&lang=js"

import "./EditorSubject.vue?vue&type=style&index=0&id=cdeceb70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdeceb70"]])

export default __exports__